import React, { useRef, useEffect } from 'react';
import './BeliefSection.css';
import { useAnimation } from '../../context/AnimationContext';

/**
 * Shared "What We Believe" section component
 * Used in both HomePage and NewGraduatePage with identical content
 */
const BeliefSection = ({ classPrefix = '' }) => {
  const prefix = classPrefix ? `${classPrefix}-` : '';
  const { animationEnabled } = useAnimation();
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      if (animationEnabled) {
        videoRef.current.play().catch(err => console.log('Video play failed:', err));
      } else {
        videoRef.current.pause();
      }
    }
  }, [animationEnabled]);

  return (
    <>
      {/* What We Believe Header and Video */}
      <section className={`${prefix}belief-section`}>
        <div className={`${prefix}belief-header`}>
          <h2 className={`${prefix}belief-title`}>Creating a Society Where Everyone Shines</h2>
          <p className={`${prefix}belief-subtitle`}>誰もが輝く社会を創る</p>
        </div>
        <div className={`${prefix}belief-image`}>
          <video 
            ref={videoRef}
            autoPlay
            muted
            loop
            playsInline
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          >
            <source src="/videos/homepage/belief.mp4" type="video/mp4" />
          </video>
        </div>
      </section>

      {/* Belief Text Section */}
      <section className={`${prefix}belief-text-section`}>
        <div className={`${prefix}belief-text-container`}>
          <p className={`${prefix}belief-text`}>
            FLARETECHでは、このミッションを達成するため、
          </p>
          <p className={`${prefix}belief-text`}>
            世界中から集まった個性豊かで信頼できるエンジニアが<br />
            短所を補い合い、長所を活かしながら、<br />
            お客さまの課題解決に向けて働いています。
          </p>
          <p className={`${prefix}belief-text`}>
            一緒に働く 仲間 を募集しています。
          </p>
        </div>
      </section>
    </>
  );
};

export default BeliefSection;
